import { z } from 'zod';
export const postalCodeOptionSchema = z.object({
    code: z.string(),
    // The code's postal town, or the municipalities it covers when it spans several, joined with a comma.
    name: z.string(),
});
export const postalCodesByCantonSchema = z.record(z.string(), z.array(postalCodeOptionSchema));
export const postalCodesInRangeSchema = z.object({
    postalCodes: z.array(z.string()),
});
export const companyLocationSchema = z.object({
    position: z.object({ lat: z.number(), lng: z.number() }).nullable(),
});
